import React from 'react';

import HomeModelGroup from '../../components/home-model-group/HomeModelGroup';
import LinkGroup from '../../components/link-group/LinkGroup';
import ModelColors from '../../components/model-colors/ModelColors';
import TabGallery from '../../components/tab-gallery/TabGallery';
import LeadSection from '../../components/lead-section/LeadSection';
import ModelHighlights from '../../components/model-highlights/ModelHighlights';
import ModelDetailParagraph from '../../components/model-detail-paragraph/ModelDetailParagraph';
import PriceListCards from '../../components/data-display/PriceListCards';
import AccordionContent from '../../components/accordion-content/AccordionContent';
import PriceAccordion from '../../components/price-accordion/PriceAccordion';
import Testimonial from '../../components/testimonial/Testimonial';
import ModelSlider from '../../components/model-slider/ModelSlider';
import LeadForm from '../../components/lead-form/LeadForm';
import FastLinks from '../../components/fast-links/FastLinks';
import TopView from '../../components/top-view/TopView';
import Experience from '../../components/360-experience/Experience';
import LeftPaddingHeadline from '../../components/title/LeftPaddingHeadline';
import LeftPaddingBlockText from '../../components/block-text/LeftPaddingBlockText';
import CampaignDetail from '../../components/campaign-detail/CampaignDetail';
import LegalCredits from '../../components/legal-credits/LegalCredits';
import HorizontalCarList from '../../components/price-list/inner-components/horizontal-car-list/HorizontalCarList';
import AccordionContentRow from '../../components/price-list/inner-components/accordion-content-row/AccordionContentRow'
import PriceList from '../../components/price-list/PriceList'
import PriceCard from '../../components/price-list/inner-components/price-card/PriceCard'
import PriceTable from '../../components/price-list/inner-components/price-table/PriceTable'
import TableHeader from '../../components/price-list/inner-components/price-table/PriceTable'
import PriceListOptionalAccrodion from '../../components/price-list-optional-accordion/PriceListOptionalAccrodion.js'
import OptionalAccordion from '../../components/optional-accordion/OptionalAccordion'
import MobileAppDownloadSection from '../../components/mobile-app-download-section/MobileAppDownloadSection'
import ModelsHead from '../../components/all-model-head/ModelsHead'
import BannerComponent from '../../components/banner-detail/BannerComponent'
import ContentLayer from '../../components/content-layer/ContentLayer'
import MobileAppSectionOnly from '../../components/mobile-app-download-section/MobileAppSectionOnly'
import ModelComparisionAccordion from '../../components/model-comparison-table/ModelComparisonAccordion'
import ModelComparisonHead from '../../components/model-comparison-head/ModelComparisonHead'
import Youtube from '../../components/youtube-container/Youtube'
import ModelComparisonCars from '../../components/model-comparison-cars/ModelComparisonCars'

//MODEL DETAIL PARAGRAPH = -1
//QUICK LINKS ILE HOME MODEL KARIŞMIŞ

//Bunlar CMS'ten gelen SchemeId değerleri.
const componentList = {
    '492': <TopView />,//ok
    '497': <FastLinks />,//ok
    '499': <LeadForm />,//ok
    '500': <HomeModelGroup />,//ok
    '501': <LinkGroup />,//ok
    '504': <ModelSlider />,//ok
    '502': <PriceListCards mode={1} />,//ok 
    '507': <ModelHighlights />,//ok
    '508': <AccordionContent />,//ok
    '505': <LeadSection inverted />,//ok
    '506': <Testimonial />,//ok
    '509': <PriceAccordion />,//ok
    '510': <TabGallery />,//ok
    '511': <Experience />,//ok
    '512': <ModelDetailParagraph/>,//ok
    '513': <ModelColors />,//ok
    '515': <LeftPaddingHeadline />,//ok
    '516': <LeftPaddingBlockText />,//ok
    '517': <LeadSection />,//ok
    '518': <LeadSection inverted />,
    '519': <LeadForm inverted/>,
    '520': <TopView inverted />,
    '524': <CampaignDetail />,
    '525': <LegalCredits />,
    '527': <HorizontalCarList />,
    '528': <MobileAppDownloadSection/>,
    '526': <ModelsHead />,
    '538': <BannerComponent />,
    '539': <ContentLayer />,
    '564': <MobileAppSectionOnly />,
    '574': <Youtube/> 
};

export const getComponent = (componentId, props) => {
    console.log(componentId, props)
    if (componentList[componentId]) {
        return React.cloneElement(componentList[componentId],props); 
    }

    return <div />;
}